import React from "react";

const Quick_Brochure = ({ btn_name, class_name }) => {
  return (
    <a
      href="/IT-Augmentation- Service-profile- TSPL.pdf"
      target="_blank"
      rel="noopener noreferrer"
      className={class_name}
    >
      {btn_name}
    </a>
  );
};

export default Quick_Brochure;